module.exports = __webpack_public_path__ + "static/Phone Validation Technical Overview EE-e4c2a917f14fa006cbfa7da074eda8d9.pdf";